import React from 'react';
import { Card, List, Tag, Typography } from 'antd';

const { Text } = Typography;

interface EvidenceSectionProps {
  sources?: string[];
  lastUpdated?: string;
}

const EvidenceSection: React.FC<EvidenceSectionProps> = ({
  sources = [],
  lastUpdated,
}) => {
  return (
    <Card title="证据与来源" style={{ marginTop: 24 }}>
      <div style={{ marginBottom: 12, color: '#666' }}>
        <Text type="secondary">
          {lastUpdated
            ? `最近更新：${new Date(lastUpdated).toLocaleDateString()}`
            : '最近更新：--'}
        </Text>
      </div>
      {sources.length > 0 ? (
        <List
          size="small"
          dataSource={sources}
          renderItem={src => (
            <List.Item>
              <a href={src} target="_blank" rel="noreferrer">
                {src}
              </a>
            </List.Item>
          )}
        />
      ) : (
        <Text type="secondary">暂无公开的数据来源链接。</Text>
      )}
      <div style={{ marginTop: 12 }}>
        <Tag color="geekblue">透明度</Tag>
        <Tag color="green">可信度</Tag>
      </div>
    </Card>
  );
};

export default EvidenceSection;
